import type { ComponentProps } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

type NavigationLinkProps = ComponentProps<typeof NavLink>;
export const NavigationLink = ({ children, className, ...props }: NavigationLinkProps) => {
    const { pathname } = useLocation();
    const topLevelSegment = props.to.toString().split('/').slice(0, 2).join('/');
    // Match on a full path segment boundary so that e.g. "/charging" does not
    // incorrectly activate for "/charging-cards".
    const isActive = pathname === topLevelSegment || pathname.startsWith(`${topLevelSegment}/`);

    return (
        <NavLink className={`${isActive ? 'active' : undefined} ${className}`} {...props}>
            {children}
        </NavLink>
    );
};
